import { defineComponent as z, useCssVars as ue, ref as Y, reactive as q, computed as m, watch as A, openBlock as y, createElementBlock as S, createElementVNode as g, normalizeClass as _, normalizeStyle as V, unref as c, Fragment as F, renderList as ie, toDisplayString as C, createCommentVNode as P, pushScopeId as ce, popScopeId as se, useSlots as ae, onMounted as re, createBlock as de, renderSlot as pe, createVNode as ge } from "vue";
var i = /* @__PURE__ */ ((n) => (n[n.Hour = 1] = "Hour", n[n.Minute = 2] = "Minute", n[n.Second = 3] = "Second", n))(i || {});
function me(n, s = "px") {
  if (!(n == null || n === ""))
    return isNaN(+n) ? String(n) : `${Number(n)}${s}`;
}
const ke = { class: "picker__body" }, ve = { class: "time-picker-clock__container" }, ye = /* @__PURE__ */ z({
  __name: "timePickerClock",
  props: {
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    color: null,
    value: null,
    selecting: null,
    min: null,
    max: null,
    step: null
  },
  emits: ["input", "change"],
  setup(n, { emit: s }) {
    const l = n;
    ue((t) => ({
      bbcd885a: n.color
    }));
    const d = Y(null), e = Y(null), p = 0.62, a = q({
      inputValue: l.value,
      isDragging: !1,
      valueOnMouseDown: null,
      valueOnMouseUp: null
    }), I = m(() => {
      const t = [];
      for (let u = l.min; u <= l.max; u = u + l.step)
        t.push(u);
      return t;
    }), b = m(() => !(l.readonly || l.disabled)), H = m(() => l.max - l.min + 1), h = m(
      () => v.value ? H.value / 2 : H.value
    ), k = m(() => 360 / h.value), o = m(() => k.value * Math.PI / 180), v = m(() => l.selecting === i.Hour), f = m(() => ({
      transform: `rotate(${k.value * (M.value - l.min)}deg) scaleY(${D(M.value)})`,
      backgroundColor: l.value !== null ? l.disabled ? "#8d7d7d" : l.color : void 0
    })), M = m(
      () => l.value == null ? l.min : l.value
    ), O = (t) => t ? v.value && t - l.min >= h.value : !1, D = (t) => O(t) ? p : 1, j = (t) => {
      const u = Math.PI / 180;
      return {
        x: Math.sin((t - l.min) * o.value + u) * D(t),
        y: -Math.cos((t - l.min) * o.value + u) * D(t)
      };
    }, G = (t) => {
      const { x: u, y: r } = j(t);
      return {
        backgroundColor: l.value !== null && t === M.value ? l.disabled ? "#8d7d7d" : l.color : void 0,
        left: `${50 + u * 50}%`,
        top: `${50 + r * 50}%`
      };
    }, U = (t, u) => {
      const r = u.x - t.x, x = u.y - t.y;
      return Math.sqrt(r * r + x * x);
    }, J = (t, u) => {
      const r = 2 * Math.atan2(u.y - t.y - U(t, u), u.x - t.x);
      return Math.abs(r * 180 / Math.PI);
    }, K = (t, u) => {
      const r = (Math.round(t / k.value) + (u ? h.value : 0)) % H.value + l.min;
      return t < 360 - k.value / 2 ? r : u ? l.max - h.value + 1 : l.min;
    }, Q = (t) => {
      a.inputValue !== t && (a.inputValue = t, s("input", t));
    }, Z = (t) => {
      a.valueOnMouseDown === null && (a.valueOnMouseDown = t), a.valueOnMouseUp = t, Q(t);
    }, $ = (t) => {
      if (b.value) {
        if (t.preventDefault(), !a.isDragging && t.type !== "click" || !d.value)
          return;
        const { width: u, top: r, left: x } = d.value.getBoundingClientRect(), { width: T } = e.value.getBoundingClientRect(), { clientX: ee, clientY: ne } = "touches" in t ? t.touches[0] : t, R = { x: u / 2, y: -u / 2 }, W = { x: ee - x, y: r - ne }, te = Math.round(J(R, W) - 0 + 360) % 360, le = v.value && U(R, W) < (T + T * p) / 4, oe = Math.ceil(15 / k.value);
        let E;
        for (let B = 0; B < oe; B++)
          return E = K(te + B * k.value, le), Z(E);
      }
    }, N = (t) => {
      b.value && (t.preventDefault(), a.valueOnMouseDown = null, a.valueOnMouseUp = null, a.isDragging = !0, $(t));
    }, w = (t) => {
      b.value && (t.stopPropagation(), a.isDragging = !1, a.valueOnMouseUp !== null && s("change", a.valueOnMouseUp));
    };
    return A(
      () => l.value,
      (t) => a.inputValue = t
    ), (t, u) => (y(), S("div", ke, [
      g("div", ve, [
        g("div", {
          ref_key: "clock",
          ref: d,
          onMousedown: N,
          onMouseup: w,
          onMouseleave: u[0] || (u[0] = (r) => a.isDragging && w(r)),
          onTouchstart: N,
          onTouchend: w,
          onMousemove: $,
          onTouchmove: $,
          class: _(["time-picker-clock", {
            "time-picker-clock--indeterminate": n.value == null
          }])
        }, [
          g("div", {
            ref_key: "innerClock",
            ref: e,
            class: "time-picker-clock__inner"
          }, [
            g("div", {
              class: _(["time-picker-clock__hand", {
                "time-picker-clock__hand--inner": O(n.value)
              }]),
              style: V({
                ...c(f)
              })
            }, null, 6),
            (y(!0), S(F, null, ie(c(I), (r) => (y(), S("span", {
              key: r,
              class: _(["time-picker-clock__item", {
                "time-picker-clock__item--active": r === c(M),
                "time-picker-clock__item--disabled": l.disabled
              }]),
              style: V(G(r))
            }, [
              g("span", null, C(n.selecting === c(i).Hour ? r : r.toString().padStart(2, "0")), 1)
            ], 6))), 128))
          ], 512)
        ], 34)
      ])
    ]));
  }
});
const L = (n, s) => {
  const l = n.__vccOpts || n;
  for (const [d, e] of s)
    l[d] = e;
  return l;
}, he = /* @__PURE__ */ L(ye, [["__scopeId", "data-v-a200f0cb"]]), X = (n) => (ce("data-v-87d9e2a6"), n = n(), se(), n), fe = { class: "time-picker-title" }, Me = { class: "time-picker-title__time" }, Se = /* @__PURE__ */ X(() => /* @__PURE__ */ g("span", null, " : ", -1)), _e = /* @__PURE__ */ X(() => /* @__PURE__ */ g("span", null, " : ", -1)), be = /* @__PURE__ */ z({
  __name: "timePickerTitle",
  props: {
    disabled: { type: Boolean },
    hour: null,
    minute: null,
    second: null,
    readonly: { type: Boolean },
    useSeconds: { type: Boolean },
    color: null,
    selecting: null
  },
  emits: ["update:selecting"],
  setup(n, { emit: s }) {
    const l = n, d = m(() => !(l.readonly || l.disabled));
    return (e, p) => (y(), S("div", {
      class: "picker__title",
      style: V({
        backgroundColor: n.color
      })
    }, [
      g("div", fe, [
        g("div", Me, [
          g("div", {
            onClick: p[0] || (p[0] = (a) => c(d) && s("update:selecting", c(i).Hour)),
            class: _(["picker__title__btn", {
              "picker__title__btn--active": c(i).Hour === n.selecting
            }])
          }, C(n.hour == null ? "--" : n.hour.toString().padStart(2, "0")), 3),
          Se,
          g("div", {
            onClick: p[1] || (p[1] = (a) => c(d) && s("update:selecting", c(i).Minute)),
            class: _(["picker__title__btn", {
              "picker__title__btn--active": c(i).Minute === n.selecting
            }])
          }, C(n.minute == null ? "--" : n.minute.toString().padStart(2, "0")), 3),
          n.useSeconds ? (y(), S(F, { key: 0 }, [
            _e,
            g("div", {
              onClick: p[2] || (p[2] = (a) => c(d) && s("update:selecting", c(i).Second)),
              class: _(["picker__title__btn", {
                "picker__title__btn--active": c(i).Second === n.selecting
              }])
            }, C(n.second == null ? "--" : n.second.toString().padStart(2, "0")), 3)
          ], 64)) : P("", !0)
        ])
      ])
    ], 4));
  }
});
const He = /* @__PURE__ */ L(be, [["__scopeId", "data-v-87d9e2a6"]]), xe = /* @__PURE__ */ z({
  __name: "timePicker",
  props: {
    disabled: { type: Boolean },
    min: null,
    max: null,
    readonly: { type: Boolean },
    hideTitle: { type: Boolean },
    fullWidth: { type: Boolean },
    useSeconds: { type: Boolean },
    automatic: { type: Boolean, default: !0 },
    color: { default: "#3ba13b" },
    modelValue: null,
    width: null
  },
  emits: ["change", "select:hour", "select:minute", "select:second", "click:hour", "click:minute", "click:second", "update:modelValue"],
  setup(n, { emit: s }) {
    const l = n, d = ae(), e = q({
      inputHour: null,
      inputMinute: null,
      inputSecond: null,
      lazyInputHour: null,
      lazyInputMinute: null,
      lazyInputSecond: null,
      selecting: i.Hour
    }), p = (o) => {
      if (o == null || o === "")
        e.inputHour = null, e.inputMinute = null, e.inputSecond = null;
      else if (o instanceof Date)
        e.inputHour = o.getHours(), e.inputMinute = o.getMinutes(), e.inputSecond = o.getSeconds();
      else if (typeof o == "string") {
        const [v, f, M] = o.split(":");
        e.inputHour = parseInt(v), e.inputMinute = parseInt(f), e.inputSecond = parseInt(M);
      }
    }, a = m(() => ({
      width: l.fullWidth ? void 0 : me(l.width || 290)
    })), I = () => e.inputHour != null && e.inputMinute != null && (!l.useSeconds || e.inputSecond != null) ? `${e.inputHour.toString().padStart(2, "0")}:${e.inputMinute.toString().padStart(2, "0")}` + (l.useSeconds ? `:${e.inputSecond.toString().padStart(2, "0")}` : "") : null, b = () => {
      const o = I();
      o !== null && s("update:modelValue", o);
    }, H = (o) => {
      switch (e.selecting = o, e.selecting) {
        case 1:
          s("click:hour");
          break;
        case 2:
          s("click:minute");
          break;
        case 3:
          s("click:second");
          break;
      }
    }, h = (o) => {
      e.selecting === i.Hour ? e.inputHour = o : e.selecting === i.Minute ? e.inputMinute = o : e.inputSecond = o, b();
    }, k = (o) => {
      switch (e.selecting) {
        case 1:
          s("select:hour", o);
          break;
        case 2:
          s("select:minute", o);
          break;
        case 3:
          s("select:second", o);
          break;
      }
      const v = e.selecting === (l.useSeconds ? i.Second : i.Minute);
      if ((l.automatic === !0 || l.automatic === void 0) && (e.selecting === i.Hour ? e.selecting = i.Minute : l.useSeconds && e.selecting === i.Minute && (e.selecting = i.Second)), e.inputHour === e.lazyInputHour && e.inputMinute === e.lazyInputMinute && (!l.useSeconds || e.inputSecond === e.lazyInputSecond))
        return;
      const f = I();
      f !== null && (e.lazyInputHour = e.inputHour, e.lazyInputMinute = e.inputMinute, l.useSeconds && (e.lazyInputSecond = e.inputSecond), v && s("change", f));
    };
    return re(() => p(l.modelValue)), A(
      () => l.modelValue,
      (o) => p(o)
    ), (o, v) => (y(), S("div", {
      style: V(c(a))
    }, [
      !n.hideTitle && !c(d).header ? (y(), de(He, {
        key: 0,
        color: n.color,
        hour: e.inputHour,
        minute: e.inputMinute,
        second: e.inputSecond,
        selecting: e.selecting,
        "use-seconds": n.useSeconds,
        disabled: n.disabled,
        readonly: n.readonly,
        "onUpdate:selecting": H
      }, null, 8, ["color", "hour", "minute", "second", "selecting", "use-seconds", "disabled", "readonly"])) : P("", !0),
      c(d).header ? pe(o.$slots, "header", {
        key: 1,
        hours: e.inputHour,
        minutes: e.inputMinute,
        seconds: e.inputSecond,
        selectHours: () => e.selecting = c(i).Hour,
        selectMinutes: () => e.selecting = c(i).Minute,
        selectSeconds: () => e.selecting = c(i).Second
      }) : P("", !0),
      ge(he, {
        disabled: n.disabled,
        readonly: n.readonly,
        color: n.color,
        onInput: h,
        onChange: k,
        "use-seconds": n.useSeconds,
        step: e.selecting === c(i).Hour ? 1 : 5,
        min: 0,
        max: e.selecting === c(i).Hour ? 23 : 59,
        selecting: e.selecting,
        value: e.selecting === c(i).Hour ? e.inputHour : e.selecting === c(i).Minute ? e.inputMinute : e.inputSecond
      }, null, 8, ["disabled", "readonly", "color", "use-seconds", "step", "max", "selecting", "value"])
    ], 4));
  }
});
export {
  xe as TimePicker
};
